import { Tier } from './tier';
import { Distributor } from './distributor';
import { DistributorContractArea } from './distributor-contract-area';

export class DistributorContract
{
	id: number;
	name: string;
	tier: Tier;
	distributor: Distributor;
	distributorContractAreas: DistributorContractArea[];
	active_from: string;
	price_per_thousand: number;
	discount: number;
  minimal_order_amount: number;
  use_folder_packet: boolean;
  folder_packet_limit: number;
  folder_packet_price: number;
	uses_gross: boolean;
	inactive: boolean;

	constructor()
	{
		this.name = null;
		this.tier = null;
		this.uses_gross = false;
		this.discount = 0;
    this.use_folder_packet = false;
    this.folder_packet_limit = 0;
    this.folder_packet_price = 0;
    this.minimal_order_amount = 0;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/distributor-contract.ts